<ng-container *ngFor="let layout of sortedLayouts()">
  <app-layout [layout]="layout"></app-layout>
</ng-container>

<ng-container *ngFor="let widget of sortedWidgets()">
  <app-widget [widget]="widget"></app-widget>
</ng-container>
